import {
    GET_PARTICIPANTS,
    GET_PARTICIPANT,
    GET_PARTICIPANT_OWN_STATS,
    PARTICIPANTS_LOADING,
    GET_PARTICIPANTS_STATS,
    GET_PARTICIPANT_COUNT_BY_CONFERENCE,
    GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE,
    GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE_BY_DAY,
    GET_CONFERENCE_STATUS,
    GET_CONFERENCE,
    GET_NUMBER_OF_PARTICIPANTS_ALL,
    GET_USERS,
    GET_CONFERENCE_LIST
  } from '../actions/types';
  
  const initialState = {
    getNumberOfParticipantsAll: [],
    getConferenceById: {},
    conferenceStatus: [],
    participantPerConference: [],
    participantPerConferenceByDay: [],
    participantStats: [],
    participantOwnStats: [],
    countParticipantsByConference: [],
    participants: [],
    users: [],
    conferenceList: [],
    participant: {},
    loading: false
  };
  
  export default function FuncState(state = initialState, action) {
    switch (action.type) {
      case GET_NUMBER_OF_PARTICIPANTS_ALL:
        return {
          ...state,
          getNumberOfParticipantsAll: action.payload,
          loading: false
        }
      case GET_CONFERENCE: 
      return {
        ...state,
        getConferenceById: action.payload,
        loading: false
      }
      case GET_CONFERENCE_STATUS:
        return {
          ...state,
          conferenceStatus: action.payload,
          loading: false
        }
      case GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE:
        return {
          ...state,
          participantPerConference: action.payload,
          loading: false
        }
        case GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE_BY_DAY:
          return {
            ...state,
            participantPerConferenceByDay: action.payload,
            loading: false
          }
      case GET_PARTICIPANTS_STATS:
        return {
          ...state,
          participantStats: action.payload,
          loading: false
        }
      case GET_PARTICIPANT_COUNT_BY_CONFERENCE:
        return {
          ...state,
          countParticipantsByConference: action.payload,
          loading: false
         }
      case GET_PARTICIPANT_OWN_STATS:
        return {
          ...state,
          participantOwnStats: action.payload,
          loading: false
        }
      case PARTICIPANTS_LOADING:
        return {
          ...state,
          loading: true
        };
      case GET_PARTICIPANTS:
        return {
          ...state,
          participants: action.payload,
          loading: false
        };
        case GET_USERS:
          return {
            ...state,
            users: action.payload,
            loading: false
          };
          case GET_CONFERENCE_LIST:
            return {
              ...state,
              conferenceList: action.payload,
              loading: false
            };
      case GET_PARTICIPANT:
        return {
          ...state,
          participant: action.payload,
          loading: false
        };
      default:
        return state;
    }
  }
  